import React, { Component } from "react";
import '../Configurations/Configuration.css'
import { ClickableCard } from "../../Components/Common Components/CommonComponents";
import {ImagePaths} from "../../Utility/ImagePaths";
import { withTranslation } from "react-i18next";
import { Colors } from "../../Styles/Colors";
import { Box, Typography } from "@mui/material";
import { CheckAccessFunc } from "../../Components/CommonFunctions/CommonFunctions";
import { localGetItem } from "../../Utility/Services/CacheProviderService";

// Define the configuration list for Histopathology
let NewHistopathologyConfigList = [
    {
        id: 0, main_title: 'Histopathology Configuration',
        sub_tab: [
            { id: 0, sub_title: 'Histopathology Masters', value: 'histoConfig', icon: ImagePaths.Histopathology.default, Access: CheckAccessFunc("Histopathology", "Settings", "Histopathology Masters", null, "Tab"), path: "/HistopathologySetting/MasterConfiguration" },
            // Add more sub-tabs for Histopathology settings here if needed
            // Example: { id: 1, sub_title: 'Lab Test Configuration', value: 'labTestConfig', icon: ImagePaths.labConfig.default, Access: CheckAccessFunc("Histopathology", "Settings", "Lab Test Config", null, "Tab"), path: "/HistopathologySetting/LabTestConfiguration" },
        ]
    },
]
let UserData = null;
let showSmsConfig = false; // Kept for consistency, although likely not directly used here without SMS config in the list

class HistopathologyConfigHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedConfigScreen: "",
            isSelected: false,
            selectedIndex: null,
        }
    }

    componentDidMount() {
        // Load user data on mount, similar to the original component
        UserData = JSON.parse(localGetItem("loggedInUserInfo"));
        // This logic is copied from the original component for completeness, 
        // but its direct relevance depends on other parts of your app
        showSmsConfig = (UserData?.sms_config && Object.keys(UserData?.sms_config)?.length > 0 && UserData?.sms_config?.to_send_sms) || UserData?.whatsapp_configuration;
    }

    // RoleWiseAccess function copied for consistency
    RoleWiseAccess(item, ListName) {
        try {
            var UserDetails = JSON.parse(localGetItem("loggedInUserInfo"))
            if (item.value === "UserAccess" && ListName === "UserConfigList") {
                return UserDetails?.is_user ? UserDetails?.is_user : true
            }
            else {
                return true
            }
        }
        catch (e) {
            return true
        }
    }

    // Navigation function adapted for Histopathology configuration
    newUserConfigNavigation(id, item) {
        this.setState({
            isSelected: true,
            selectedIndex: id ?? null,
            selectedConfigScreen: item?.value
        }, () => {
            let { history } = this.props
            if (this.state.selectedIndex === item?.id) {
                history.push({ pathname: item?.path })
            }
        })
    }

    render() {
        let { isSelected, selectedIndex } = this.state;
        // Use NewHistopathologyConfigList for mapping
        return (
            <Box component='div' className="eMed_Config_Wrapper" style={{ backgroundColor: Colors.configHomeBg }}>
                {NewHistopathologyConfigList?.map((item, index) => {
                    return (
                        <Box component={'div'} className="eMed_Config_Div" key={index}>
                            {/* Check if any sub-tab has view access before displaying the main title */}
                            <Box component={'div'} display={item.sub_tab?.some(sub => CheckAccessFunc("Histopathology", "Settings", sub.sub_title, null, "Tab")?.viewAccess) ? 'inline' : 'none'}>
                                <Typography id="eMed_Config_header">{item?.main_title}</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexWrap={'wrap'}>
                                {item?.sub_tab?.map((sub, subIndex) => {
                                    // The console.log is retained from the original, but can be removed in production
                                    // console.log(CheckAccessFunc("Histopathology", "Settings", sub.sub_title, null, "Tab")); 
                                    
                                    // Check for view access before rendering the ClickableCard
                                    if (CheckAccessFunc("Histopathology", "Settings", sub.sub_title, null, "Tab")?.viewAccess) {
                                        return (
                                            <Box component={'div'} key={subIndex} id="eMed_Config_mainDiv">
                                                <ClickableCard 
                                                    label={sub.sub_title} 
                                                    icon={sub.icon} 
                                                    width={"4vw"} 
                                                    height={"4vw"} 
                                                    isSelected={isSelected && selectedIndex === sub.id ? true : false} // Changed to sub.id for robust selection
                                                    onClick={() => this.newUserConfigNavigation(sub.id, sub)} 
                                                />
                                            </Box>
                                        )
                                    }
                                    return null; // Return null if no view access
                                })}
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        )
    }
}
export default withTranslation()(HistopathologyConfigHome);